import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export async function downloadFile(path, fallbackName = "file.xlsx") {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  const cd = res.headers["content-disposition"] || "";
  a.download = cd.match(/filename=([^;]+)/)?.[1]?.trim() || fallbackName;
  a.click();
  URL.revokeObjectURL(url);
}

export async function importFile(path, file) {
  const fd = new FormData();
  fd.append("file", file);
  return api.post(path, fd, { headers: { "Content-Type": "multipart/form-data" } });
}

export default api;
